/**
 * Get path of AppConfiguration.json.
 * This path is tipically stored into global variable DoraG_AppConfigurationPath.
 * If DoraG_AppConfigurationPath is undefined return a default value.
 * @return {string} Value of global variable DoraG_AppConfigurationPath. If doesn't exist 'assets/AppConfiguration.json'.
 */
function extGetAppConfigurationPath() {
  if (typeof DoraG_AppConfigurationPath !== 'undefined')
    return DoraG_AppConfigurationPath;

  return '';
}

function DoraGetLocale() {
  if (typeof DoraLocale !== 'undefined')
    return DoraLocale;

  // read from GET
  let locale = findGetParameter('locale');
  if (locale !== null){
    return locale;
  }

  // search Drupal
  locale = getDrupalLocale();
  if (locale !== null){
    return locale;
  }

  // default
  return 'it';
}

/**
 * Get project form Drupal module msg_datamanagement if exist
 * @return {string|*}
 * @constructor
 */
function DoraGetProject() {
  if (typeof drupalSettings !== 'undefined' &&
    typeof drupalSettings.msg_datamanagement !== 'undefined' &&
    typeof drupalSettings.msg_datamanagement.project !== 'undefined'){

    return drupalSettings.msg_datamanagement.project;
  }

  return '';
}
function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  var params = location.search
    .substr(1)
    .split("&");

  for (var idx=0; idx < params.length; idx++){
    var item = params[idx];
      tmp = item.split("=");
      if (tmp[0] === parameterName)
        result = decodeURIComponent(tmp[1]);
    }

  return result;
}

/**
 * In Drupal url format is [domain]/[ll]/[....]
 * where [ll] = 2 digits representing locale eg. it,en, ...
 */
function getDrupalLocale() {
  var parts = location.pathname.split("/");

  for (var i=1; i < parts.length; i++){
    if (parts[i].length === 2)
      return parts[i];

  }

  // not found
  return null;

}
